const downloadMenukaartSelector = document.querySelector('[data-download-menukaart]');

export default function initDownloadMenukaarten() {
    // Start download when user selects a menucard
    if (downloadMenukaartSelector) {
        downloadMenukaartSelector.addEventListener('change', (e) => {
            e.preventDefault();
            window.open(e.target.value, '_blank').focus();
        });
    }
}
